module.exports = __webpack_public_path__ + "img/FairbridgesLogo.dfa74c55.png";